var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.166A12.206 12.206 0 0 1 12 16V21h2l9-9-9-9h-2v5.027c-4.83.778-9.14 4.069-10.652 9.724a6.12 6.12 0 0 0-.06.249c-.132.592-.22 1.336-.288 2h1.75c.096-.096.194-.191.292-.285 1.964-1.86 4.359-3.118 6.958-3.55Zm-6.102.322C6.276 14.915 9.048 14 12 14h2v4.17L20.172 12 14 5.828v3.903l-1.682.27c-3.578.577-6.794 2.747-8.42 6.487Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7fce0aa795a9c44b036ac4091d662c4b.svg";
export { ForwardRef as ReactComponent };